import React from "react";
import Banner from "../../Components/Layout/Gps/Banner";
import Buttons from "../../Components/Layout/Gps/Buttons";
import CallUs from "../../Components/Layout/Gps/CallUs";
import Products from "../../Components/Layout/Gps/Products";
import VehicleTracking from "../../Components/Layout/Gps/VehicleTracking";
import SpecialFeature from "../../Components/Layout/Gps/SpecialFeature";
import GpsFeature from "../../Components/Layout/Gps/GpsFeature";
import Middlebanner from "../../Components/Layout/Home/Middlebanner";
import Vehicles from "../../Components/Layout/Gps/Vehicles";

const Gps = () => {
  return (
    <div>
      <Banner />
      <Buttons />
      <CallUs />
      <Products />
      <VehicleTracking />
      <SpecialFeature />
      <GpsFeature />
      <Vehicles />
      <Middlebanner />
    </div>
  );
};

export default Gps;
